import FileSaver from 'file-saver';
import { actions as jobActions } from '@saucelabs/sl-module-jobs';

import { FILE_TO_URL_MAPPING_RDC } from '../container/constants';

import { actions, constants } from '.';

export const fetchAndDisplayFile = ({
  availableFiles, auth, job, assetName, config = {},
}) => (dispatch) => {
  dispatch(actions.selectFile(assetName));
  dispatch(actions.showLoader());

  // NOTE: Some types of tests will have non-text assets that we want to surface
  // in the log dropdown, but obviously don't want to download and render on selection.
  if (typeof assetName === 'string' && assetName.endsWith('.zip')) {
    dispatch(actions.attachFile({
      name: assetName,
      data: '',
      status: constants.STATUS.SKIPPED,
    }));
    return null;
  }

  const fileAlreadyDownloaded = availableFiles.get(assetName);

  if (fileAlreadyDownloaded) {
    return fileAlreadyDownloaded.status === 'SUCCESS' ?
      dispatch(actions.attachFile({ name: assetName, data: fileAlreadyDownloaded.data })) :
      dispatch(actions.exceedFileSize({ name: assetName }));
  }

  if (job.isRdc()) {
    return null;
  }

  const assetFetchMethod = constants.EDS_SPECIFIC_FILENAMES.includes(assetName) ?
    jobActions.getEdsAsset.bind(jobActions.getEdsAsset) :
    jobActions.getAsset.bind(jobActions.getAsset);

  return dispatch(assetFetchMethod({
    id: job.id,
    auth,
    assetName,
    config,
  }, { skipErrorPage: true }))
    .then(({ data }) => dispatch(actions.attachFile({ name: assetName, data })))
    .catch(() => null);
};

export const getBlobFile = ({ assetName, auth, job }) => (dispatch) => {
  if (job.isRdc()) {
    const { urlKey, config = {} } = FILE_TO_URL_MAPPING_RDC[assetName];
    const url = job.get(urlKey);

    return dispatch(jobActions.getRdcAsset({ url, config }, { skipErrorPage: true }))
      .then((response) => {
        let { data } = response;

        if (constants.RDC_SPECIFIC_FILENAMES.includes(assetName)) {
          data = JSON.stringify(data, null, 4);
        }
        FileSaver.saveAs(new Blob([data]), assetName);
      });
  }

  const axiosOptions = {
    id: job.get('id'),
    assetName,
    auth,
    config: {
      responseType: 'blob',
    },
  };

  const assetFetchMethod = constants.EDS_SPECIFIC_FILENAMES.includes(assetName) ?
    jobActions.getEdsAsset.bind(jobActions.getEdsAsset) :
    jobActions.getAsset.bind(jobActions.getAsset);

  return dispatch(assetFetchMethod(axiosOptions, { skipErrorPage: true }))
    .then((response) => {
      FileSaver.saveAs(response?.data, assetName);
    });
};

export const selectRightPanelTab = (tab) => (dispatch) => dispatch(
  actions.selectRightPanelTab(tab));

export const selectLeftPanelTab = (tab) => (dispatch) => dispatch(
  actions.selectLeftPanelTab(tab));
